import { t } from "@/i18n-js/instance";

import { SignedIdImageDropzone } from "./SignedIdImageDropzone";

export const OpenGraphImageDropzone = () => (
  <SignedIdImageDropzone
    fieldName="meta_tag_attributes.opengraph_image"
    uploadFieldName="opengraph_image"
    fileLabel={t("meta_tag_attributes.opengraph_image")}
    title={t("spaces.form.edit.options.seo.opengraph_image.add")}
    description={t("spaces.form.edit.options.seo.opengraph_image.description")}
    testId="quick-post-v3-opengraph-image-dropzone"
  />
);
